import { render } from "./SeoRelatedTools.vue?vue&type=template&id=411246b4&scoped=true"
import script from "./SeoRelatedTools.vue?vue&type=script&lang=js"
export * from "./SeoRelatedTools.vue?vue&type=script&lang=js"

import "./SeoRelatedTools.vue?vue&type=style&index=0&id=411246b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411246b4"]])

export default __exports__